
const PrimaryButton = (props) => {
    return (
        <button style={props.style} className={`${props.className} btn-red-sm`} type={props.type} onClick={props.onClick} >{props.children}</button>
    )
}

export default PrimaryButton